import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from '@/components/ui/table'
import type { PersonTimelineDds } from '@/types'
import { formatDateToDisplay } from '@/utils/formatDate'
import {
	TimelineEmptyState,
	TimelineSectionHeading,
} from '../person-timeline-modal'

export function DdsTimelineSection({ data }: { data: PersonTimelineDds }) {
	return (
		<div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
			<div className="flex flex-col gap-2">
				<TimelineSectionHeading>
					Ministrados ({data.ministered.total})
				</TimelineSectionHeading>
				{data.ministered.items.length === 0 ? (
					<TimelineEmptyState label="Nenhum DDS ministrado no período." />
				) : (
					<div className="rounded-lg border border-kaefer-light-silver">
						<Table className="table-fixed">
							<TableHeader>
								<TableRow className="bg-muted/30">
									<TableHead className="w-24">Data</TableHead>
									<TableHead>Assunto</TableHead>
									<TableHead className="w-28">Tipo</TableHead>
								</TableRow>
							</TableHeader>
							<TableBody>
								{data.ministered.items.map((item) => (
									<TableRow key={item.id}>
										<TableCell className="whitespace-nowrap text-muted-foreground">
											{formatDateToDisplay(item.date)}
										</TableCell>
										<TableCell className="whitespace-normal wrap-break-word">
											{item.subject}
										</TableCell>
										<TableCell className="text-muted-foreground">
											{item.type}
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</div>
				)}
			</div>

			<div className="flex flex-col gap-2">
				<TimelineSectionHeading>
					Participados ({data.attended.total})
				</TimelineSectionHeading>
				{data.attended.items.length === 0 ? (
					<TimelineEmptyState label="Nenhuma participação em DDS no período." />
				) : (
					<div className="rounded-lg border border-kaefer-light-silver">
						<Table className="table-fixed">
							<TableHeader>
								<TableRow className="bg-muted/30">
									<TableHead className="w-24">Data</TableHead>
									<TableHead>Assunto</TableHead>
									<TableHead className="w-32">Ministrado por</TableHead>
								</TableRow>
							</TableHeader>
							<TableBody>
								{data.attended.items.map((item) => (
									<TableRow key={item.id}>
										<TableCell className="whitespace-nowrap text-muted-foreground">
											{formatDateToDisplay(item.date)}
										</TableCell>
										<TableCell className="whitespace-normal wrap-break-word">
											{item.subject}
										</TableCell>
										<TableCell className="text-muted-foreground">
											{item.ministeredBy}
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</div>
				)}
			</div>
		</div>
	)
}
